import styled from '@emotion/styled'
import { Box } from '@mui/material'

export const Container = styled(Box)`
  width: 100%;
  display: flex;
  justify-content: center;
  height: 48px;
  gap: 4px;
  background: #f9f9f9;
  padding: 12px 20px;
`
export const boxWrapper = {
  flex: 1,
}

export const attributeValue = {
  fontWeight: 800,
}

export const titleTypography = {
  maxWidth: '90%',
  whiteSpace: 'nowrap',
}

export const textFieldStyle = {
  width: '100px',
  right: '20px',
  top: '2px',
  '& .MuiOutlinedInput-root': {
    boxSizing: 'border-box',
    height: '25px',
    '& input': {
      padding: '5px',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: 'inherit',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: 'inherit',
    },
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'gray',
  },
  '& .MuiFormHelperText-root': {
    whiteSpace: 'nowrap',
    fontSize: '0.8rem',
    padding: 0,
    margin: 0,
  },
}

export const textFieldStyleOnError = {
  width: '100px',
  right: '20px',
  bottom: '8px',
  '& .MuiOutlinedInput-root': {
    boxSizing: 'border-box',
    height: '25px',
    '& input': {
      padding: '5px',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: 'inherit',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: 'inherit',
    },
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'gray',
  },
  '& .MuiFormHelperText-root': {
    whiteSpace: 'nowrap',
    fontSize: '0.8rem',
    padding: 0,
    margin: 0,
  },
}

export const textFieldWarningStyleOnError = {
  width: '100px',
  right: '20px',
  bottom: '8px',

  '& .MuiOutlinedInput-root': {
    boxSizing: 'border-box',
    height: '25px',
    '& input': {
      padding: '5px',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: 'inherit',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: 'inherit',
    },
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'gray',
  },
  '& .MuiFormHelperText-root': {
    color: 'orange',
    whiteSpace: 'nowrap',
    fontSize: '0.8rem',
    padding: 0,
    margin: 0,
  },
}
